import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonashikcabhire() {



  const cardData =
  {
    keyword: 'Pune to Nasik Cabs Hire',
    heading: 'Sai Trupti Cabs: Pune to Nasik Cabs Hire',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Nasik cab hire services, designed to make your inter-city journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Nasik. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Nasik convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Nasik with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga",
    "description": "Situated about 28 km from the city centre, Trimbakeshwar Jyotirlinga stands at the foot of Brahmagiri hills where the sacred Godavari River originates. This ancient temple, dedicated to Lord Shiva, houses one of the twelve Jyotirlingas — the shimmering three-faced linga symbolising Brahma, Vishnu and Mahesh. Built in black stone with Hemadpanthi architecture, it reflects both sanctity and royal patronage. Pilgrims come here to perform rigorous rituals, bathe in the holy waters, and seek spiritual cleansing. The surrounding forested hills add a serene, other-worldly backdrop, making Trimbakeshwar more than just a temple — it’s a deeply spiritual escape from the everyday hustle."
  },
  {
    "title": "Panchvati & Kalaram Temple",
    "description": "The area of Panchvati in Nashik is steeped in mythological tales from the Ramayana and remains a spiritual hub beside the Godavari River. At its heart lies the Kalaram Temple — remarkable for its rare black statue of Lord Rama, flanked by Sita and Lakshmana, all carved in black stone. This location is believed to be where Rama lived during his exile and witnessed key events in the epic. Pilgrims gather by Ramkund, take holy dips, and wander the sacred banyan-tree groves. Evening aartis, devotional songs echoing through the river-gless banks, and the warm glow of lamps create an atmosphere of timeless devotion."
  },
  {
    "title": "Pandavleni Caves",
    "description": "Perched on the Trirashmi (also called Trymbak) hills just 8 km from Nashik city, the 24 rock-cut Pandavleni Caves date back over two millennia and reflect early Buddhist workmanship. Carved out of basalt, the caves include chaityas (prayer halls), vihara cells and sculpted rock facades, perched high above with panoramic views of the valley below. The climb up the stone steps with swaying trees and distant chirps rewards you with tranquility, history and fresh air. Ideal for history buffs and nature lovers alike, Pandavleni blends spiritual calm and archaeological intrigue in equal measure."
  },
  {
    "title": "Sula Vineyards",
    "description": "Nashik is often called the wine-capital of India, and Sula Vineyards stands at the centre of this modern transformation. Spread over lush vineyards with rolling hills as backdrop, Sula invites visitors to explore wine-tasting sessions, cellar tours, gourmet dining and relaxed strolls among grapevines. During the harvest season, the landscape glows golden, making it a photographer’s delight. Sula stands as proof that Nashik is not just about temples — it’s also about leisure, elegance and contemporary experience, all set against the Malabar foothills."
  },
  {
    "title": "Dudhsagar Falls & Dugarwadi Trek",
    "description": "For nature-seekers, the scenic trail to Dudhsagar Falls (also spelled Dugarwadi) just outside Nashik offers a refreshing retreat. Cascading waters, lush greenery, monsoon-soaked rocks, and mist rising in the early morning create a magical ambience. Trekking through forest tracks, stopping at viewpoints, and feeling the spray of waterfalls evokes a sense of wild renewal. This spot reminds visitors that Nashik isn’t only a pilgrimage town — it’s also a place where the wild hills, fresh air and the call of nature beckon you away from urban rush."
  },
  {
    "title": "Saptashrungi Temple",
    "description": "High up on a forested hill in the Satmala range near Nashik, the Saptashrungi Temple is dedicated to Goddess Saptashrungi Nivasini and is a major pilgrimage site in its own right. The climb up the rugged steps through verdant pathways and the final glimpse of the colourful temple against the sky feel exhilarating. Legends say the goddess defeated a demon here, making the temple a symbol of divine power and feminine energy. The panoramic views, the sheer altitude, and the spirited chants of the devotees create a memorable spiritual high — in both senses."
  },
  {
    "title": "Ramkund & Godavari Ghat",
    "description": "Ramkund, nestled in the heart of Nashik on the banks of the Godavari, is a sacred bathing site where pilgrims believe Lord Rama once bathed and took shelter. Thousands gather here especially during the grand Kumbh Mela series, offering prayers, lighting lamps, and whispering wishes into the flowing water. The adjacent ghats, colonnades, and river-views lend an atmosphere of timeless devotion and peace. Early-morning reflections, gentle chants echoing over the river, and the fragrance of incense make Ramkund a place to pause, reflect and connect."
  },
  {
    "title": "Anjaneri Hill & Trek",
    "description": "Anjaneri Hill, believed to be the birthplace of Lord Hanuman, is a verdant ridge near Nashik offering both spiritual significance and panoramic vantage. The ancient temple at the base gives way to a hiking trail winding through shola forest patches, rock-ledges and mist-clad slopes. At sunrise, the view of the horizon stretching across the valley is spectacular. Ideal for trekkers and day-wanderers, Anjaneri offers a blend of myth, adventure and lush nature — quietly beckoning travellers off the beaten track."
  },
  {
    "title": "Muktidham Temple Complex",
    "description": "Located in Nashik Road suburb, the Muktidham marble temple complex is famous for its pristine white facades, replicas of all twelve Jyotirlingas, and vivid murals depicting scenes from the Bhagavad Gita and Ramayana. Built of Makrana marble, it resonates with refinement and devotion. Visitors stroll through gardens, take a dip in the temple tanks, and spend time in the calm prayer halls. Muktidham offers a modern-temple experience in Nashik — where peace, art and spirituality converge beautifully."
  },
  {
    "title": "Gargoti Museum",
    "description": "Off the main pilgrimage-trail, the Gargoti Museum in nearby Sinnar is a fascinating gem-and-mineral museum showcasing rare crystals, fossils, semi-precious stones and zeolites from across India. More than just rocks and minerals, the displays and sculptures bring science, art and geology together. It’s a great stop for families or curious minds wanting a break from temples and vines. Nashik thus shows its multifaceted character — spiritual, natural, scientific and fun."
  }
],



"services": [
  {
    "name": "Pune to Nasik Cabs Hire",
    "description": "Hire reliable cabs from Pune to Nasik offering comfortable, safe, and timely travel. Choose from multiple vehicle options like Sedan, Ertiga, and Innova with AC/non-AC choices, professional drivers, flexible pickups, and transparent pricing for business or leisure trips."
  },
  {
    "name": "Pune to Nasik Taxi Service",
    "description": "Book professional taxi service from Pune to Nasik for a smooth and hassle-free ride. Our fleet includes AC/non-AC cabs, skilled drivers, real-time tracking, and flexible timings to suit your travel needs for family or corporate travel."
  },
  {
    "name": "Pune to Nasik Car Hire",
    "description": "Car hire service from Pune to Nasik offering a wide range of vehicles from Sedans to SUVs. Enjoy affordable fares, well-maintained cars, professional chauffeurs, and flexible pickup/drop options for long-distance and local travel."
  },
  {
    "name": "Pune to Nasik AC Cab",
    "description": "Travel from Pune to Nasik in a fully air-conditioned cab ensuring maximum comfort on long routes. Well-maintained vehicles, polite drivers, and smooth travel experience make this service ideal for family, business, or vacation trips."
  },
  {
    "name": "Pune to Nasik Non AC Cab",
    "description": "Affordable non-AC cab service from Pune to Nasik designed for travelers looking for budget-friendly travel options. Enjoy comfortable seating, reliable drivers, and transparent pricing for one-way or round-trip bookings."
  },
  {
    "name": "Luxury Cab Pune to Nasik",
    "description": "Experience premium travel with luxury cab service from Pune to Nasik featuring top-class Sedans and SUVs. Perfect for weddings, VIP guests, or corporate executives, offering elegant interiors, AC comfort, and professional chauffeur service."
  },
  {
    "name": "Pune to Nasik Innova Cab",
    "description": "Spacious and comfortable Innova cabs for Pune to Nasik trips. Ideal for families or groups, offering AC service, ample luggage space, professional drivers, and smooth long-distance travel experience."
  },
  {
    "name": "Pune to Nasik Ertiga Cab",
    "description": "Book an Ertiga cab from Pune to Nasik for convenient and affordable travel. Perfect for families or small groups, with AC/non-AC options, professional drivers, and reliable intercity travel at budget-friendly rates."
  },
  {
    "name": "Affordable Pune to Nasik Cab",
    "description": "Get budget-friendly Pune to Nasik cab service with no hidden charges. Well-maintained vehicles, AC/non-AC options, professional drivers, and comfortable rides for family, business, or airport transfers."
  },
  {
    "name": "Pune to Nasik Outstation Cab",
    "description": "Reliable outstation cab service from Pune to Nasik for long-distance trips. Choose from a range of vehicles with AC/non-AC options, skilled drivers, flexible booking, and transparent fares for weekend or business travel."
  },
  {
    "name": "Pune to Nasik Online Booking",
    "description": "Book your Pune to Nasik cab online in seconds with secure payment options, multiple car types, and real-time booking confirmation. Enjoy easy scheduling, professional drivers, and transparent fares for one-way and round trips."
  },
  {
    "name": "Pune to Nasik Wedding Cab",
    "description": "Hire luxury cabs from Pune to Nasik for weddings and special occasions. Offering premium vehicles, professional drivers, AC service, flexible pickup points, and timely arrivals to ensure a comfortable and elegant travel experience."
  },
  {
    "name": "Pune to Nasik Corporate Cab",
    "description": "Corporate cab hire service from Pune to Nasik tailored for business professionals. Includes executive vehicles, professional chauffeurs, flexible schedules, and online invoicing for a seamless business travel experience."
  },
  {
    "name": "Pune to Nasik Drop Cab",
    "description": "One-way drop cab service from Pune to Nasik with flexible timings, AC/non-AC options, professional drivers, and comfortable seating. Ideal for travelers seeking point-to-point transfers at affordable prices."
  },
  {
    "name": "Pune to Nasik One Way Cab",
    "description": "Book one-way cabs from Pune to Nasik at affordable rates. Enjoy direct travel with professional drivers, clean vehicles, flexible pickup options, and transparent fares — perfect for hassle-free intercity journeys."
  }
],
"tableData": [
  ["Pune to Nasik Cabs Hire", "Pune to Nasik Taxi Service"],
  ["Pune to Nasik Car Hire", "Pune to Nasik AC Cab"],
  ["Pune to Nasik Non AC Cab", "Luxury Cab Pune to Nasik"],
  ["Pune to Nasik Innova Cab", "Pune to Nasik Ertiga Cab"],
  ["Affordable Pune to Nasik Cab", "Pune to Nasik Outstation Cab"],
  ["Pune to Nasik Online Booking", "Pune to Nasik Wedding Cab"],
  ["Pune to Nasik Corporate Cab", "Pune to Nasik Drop Cab"],
  ["Pune to Nasik One Way Cab", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Nasik Cabs Hire",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Nasik — ideal for business trips, leisure travel, or vineyard tours."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear one-way fare estimates for Pune to Nasik cabs, starting at affordable rates depending on the car type — no hidden charges or surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, or premium cars to match your group size, luggage, and comfort preferences for the Pune–Nasik route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with the Pune to Nasik route, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from anywhere in Pune (city, airport, or suburbs) and drop-offs anywhere in Nasik — including railway stations, hotels, or residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and maintained to ensure comfort and reliability for your journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated team is available round-the-clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Nasik cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]





















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Nashik cab hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Nashik cab hire services for one way, round trip, and outstation travel needs.',
  },
  {
    question: 'How can I hire a cab from Pune to Nashik with Sai Trupti Cabs?',
    answer: 'You can easily hire your Pune to Nashik cab through our website, mobile app, or by contacting our 24×7 customer support team for assistance.',
  },
  {
    question: 'What types of cabs are available for Pune to Nashik hire?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers to suit your comfort, group size, and budget.',
  },
  {
    question: 'Are the drivers professional and experienced for Pune to Nashik routes?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance highway routes like Pune to Nashik, ensuring a safe and pleasant journey.',
  },
  {
    question: 'Can I book Pune to Nashik cabs for family, business, or pilgrimage trips?',
    answer: 'Certainly. Our Pune to Nashik cab hire service is ideal for family outings, business trips, Shirdi darshan, and leisure travel.',
  },
  {
    question: 'Is the Pune to Nashik cab hire service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab hire between Pune and Nashik, allowing you to plan your travel at any convenient time.',
  },
  {
    question: 'What are the Pune to Nashik cab hire fares?',
    answer: 'Our Pune to Nashik cab fares start from approximately ₹2,800 for sedans and ₹3,500–₹4,500 for SUVs and Innova Crysta, depending on cab type and travel preferences.',
  },
  {
    question: 'What payment options are available for Pune to Nashik cab hire?',
    answer: 'We accept payments through UPI, credit/debit cards, bank transfers, and digital wallets for a seamless and secure booking experience.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Nashik cabs?',
    answer: 'All our cabs are sanitized before every trip, and our drivers follow strict hygiene and safety protocols to ensure a clean and secure ride.',
  },
  {
    question: 'Is customer support available during the Pune to Nashik cab journey?',
    answer: 'Yes, our dedicated 24×7 customer support team is available throughout your Pune to Nashik cab journey to assist you with any queries.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Kulkarni',
    feedback: 'I booked a Pune to Nashik cab with Sai Trupti Cabs and had a very comfortable trip. The driver was polite and the car was in great condition.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meenal Deshmukh',
    feedback: 'Excellent Pune to Nashik cab hire experience. Sai Trupti Cabs provided a clean car, professional driver, and on-time pickup.',
    rating: 5,
  },
];





















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Nasik Cabs Hire",
  "image": "https://saitrupticabs.com/assets/images/pune-to-nasik-cabs.jpg",
  "description": "Hire reliable cabs from Pune to Nasik for corporate trips, weddings, or personal travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1499",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-nasik-cabs-hire"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pune to Nasik Cabs Hire | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Hire reliable cabs from Pune to Nasik for corporate trips, weddings, or personal travel. Choose from AC, Non-AC, Innova, Ertiga, or luxury cabs. Affordable online booking available 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune to Nasik Cabs Hire, Pune to Nasik Taxi Service, Pune to Nasik Car Hire, Pune to Nasik AC Cab, Pune to Nasik Non AC Cab, Luxury Cab Pune to Nasik, Pune to Nasik Innova Cab, Pune to Nasik Ertiga Cab, Affordable Pune to Nasik Cab, Pune to Nasik Outstation Cab, Pune to Nasik Online Booking, Pune to Nasik Wedding Cab, Pune to Nasik Corporate Cab, Pune to Nasik Drop Cab, Pune to Nasik One Way Cab" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetonashikcabhire;